import {
    transition,
    trigger,
    query,
    style,
    animate,
    group,
    animateChild
 } from '@angular/animations';



export const slideInAnimation =
 trigger('routeAnimations', [
   transition('HomePage => SolutionsPage', slideTo('right') ),
   transition('HomePage => CryptmiPage', slideTo('right') ),
   transition('HomePage => VisaPage', slideTo('right') ),
   transition('HomePage => MenaPage', slideTo('right') ),
   transition('HomePage => AboutPage', slideTo('right') ),
   transition('HomePage => NewsPage', slideTo('right') ),
   transition('HomePage => WorldPage', slideTo('right') ),
   transition('HomePage => ImaginePage', slideTo('right') ),
   transition('HomePage => gmixPage', slideTo('right') ),
   transition('HomePage => StartFormPage', slideTo('right') ),

   transition('SolutionsPage => HomePage', slideTo('left') ),
   transition('SolutionsPage => CryptmiPage', slideTo('right') ),
   transition('SolutionsPage => VisaPage', slideTo('right') ),
   transition('SolutionsPage => MenaPage', slideTo('right') ),
   transition('SolutionsPage => AboutPage', slideTo('right') ),
   transition('SolutionsPage => NewsPage', slideTo('right') ),
   transition('SolutionsPage => WorldPage', slideTo('right') ),
   transition('SolutionsPage => ImaginePage', slideTo('right') ),
   transition('SolutionsPage => gmixPage', slideTo('right') ),
   transition('SolutionsPage => StartFormPage', slideTo('right') ),


   transition('CryptmiPage => HomePage', slideTo('left') ),
   transition('CryptmiPage => SolutionsPage', slideTo('left') ),
   transition('CryptmiPage => VisaPage', slideTo('right') ),
   transition('CryptmiPage => MenaPage', slideTo('right') ),
   transition('CryptmiPage => AboutPage', slideTo('right') ),
   transition('CryptmiPage => NewsPage', slideTo('right') ),
   transition('CryptmiPage => StartFormPage', slideTo('right') ),



   transition('VisaPage => HomePage', slideTo('left') ),
   transition('VisaPage => SolutionsPage', slideTo('left') ),
   transition('VisaPage => CryptmiPage', slideTo('left') ),
   transition('VisaPage => MenaPage', slideTo('right') ),
   transition('VisaPage => AboutPage', slideTo('right') ),
   transition('VisaPage => NewsPage', slideTo('right') ),
   transition('VisaPage => WorldPage', slideTo('right') ),
   transition('VisaPage => ImaginePage', slideTo('right') ),
   transition('VisaPage => gmixPage', slideTo('right') ),
   transition('VisaPage => StartFormPage', slideTo('right') ),


   transition('MenaPage => HomePage', slideTo('left') ),
   transition('MenaPage => SolutionsPage', slideTo('left') ),
   transition('MenaPage => CryptmiPage', slideTo('left') ),
   transition('MenaPage => VisaPage', slideTo('left') ),
   transition('MenaPage => AboutPage', slideTo('right') ),
   transition('MenaPage => NewsPage', slideTo('right') ),
   transition('MenaPage => WorldPage', slideTo('right') ),
   transition('MenaPage => ImaginePage', slideTo('right') ),
   transition('MenaPage => gmixPage', slideTo('right') ),
   transition('MenaPage => StartFormPage', slideTo('right') ),


   transition('WorldPage => HomePage', slideTo('left') ),
   transition('WorldPage => SolutionsPage', slideTo('left') ),
   transition('WorldPage => VisaPage', slideTo('left') ),
   transition('WorldPage => MenaPage', slideTo('left') ),
   transition('WorldPage => ImaginePage', slideTo('right') ),
   transition('WorldPage => AboutPage', slideTo('right') ),
   transition('WorldPage => NewsPage', slideTo('right') ),
   transition('WorldPage => gmixPage', slideTo('right') ),
   transition('WorldPage => StartFormPage', slideTo('right') ),


   transition('ImaginePage => HomePage', slideTo('left') ),
   transition('ImaginePage => SolutionsPage', slideTo('left') ),
   transition('ImaginePage => VisaPage', slideTo('left') ),
   transition('ImaginePage => MenaPage', slideTo('left') ),
   transition('ImaginePage => WorldPage', slideTo('left') ),
   transition('ImaginePage => AboutPage', slideTo('right') ),
   transition('ImaginePage => NewsPage', slideTo('right') ),
   transition('ImaginePage => gmixPage', slideTo('right') ),
   transition('ImaginePage => StartFormPage', slideTo('right') ),

  transition('StartFormPage => HomePage', slideTo('left') ),
   transition('StartFormPage => SolutionsPage', slideTo('left') ),
   transition('StartFormPage => VisaPage', slideTo('left') ),
   transition('StartFormPage => MenaPage', slideTo('left') ),
   transition('StartFormPage => WorldPage', slideTo('left') ),
   transition('StartFormPage => AboutPage', slideTo('left') ),
   transition('StartFormPage => NewsPage', slideTo('left') ),
   transition('StartFormPage => gmixPage', slideTo('left') ),
   transition('StartFormPage => ImaginePage', slideTo('left') ),


   transition('AboutPage => HomePage', slideTo('left') ),
   transition('AboutPage => SolutionsPage', slideTo('left') ),
   transition('AboutPage => CryptmiPage', slideTo('left') ),
   transition('AboutPage => VisaPage', slideTo('left') ),
   transition('AboutPage => MenaPage', slideTo('left') ),
   transition('AboutPage => NewsPage', slideTo('right') ),
   transition('AboutPage => WorldPage', slideTo('left') ),
   transition('AboutPage => ImaginePage', slideTo('left') ),
   transition('AboutPage => gmixPage', slideTo('left') ),
   transition('AboutPage => StartFormPage', slideTo('right') ),


   transition('NewsPage => HomePage', slideTo('left') ),
   transition('NewsPage => SolutionsPage', slideTo('left') ),
   transition('NewsPage => CryptmiPage', slideTo('left') ),
   transition('NewsPage => VisaPage', slideTo('left') ),
   transition('NewsPage => MenaPage', slideTo('left') ),
   transition('NewsPage => AboutPage', slideTo('left') ),
   transition('NewsPage => WorldPage', slideTo('left') ),
   transition('NewsPage => ImaginePage', slideTo('left') ),
   transition('NewsPage => gmixPage', slideTo('left') ),
   transition('NewsPage => StartFormPage', slideTo('right') ),

   transition('gmixPage => HomePage', slideTo('left') ),
   transition('gmixPage => SolutionsPage', slideTo('left') ),
   transition('gmixPage => CryptmiPage', slideTo('left') ),
   transition('gmixPage => VisaPage', slideTo('left') ),
   transition('gmixPage => MenaPage', slideTo('left') ),
   transition('gmixPage => AboutPage', slideTo('right') ),
   transition('gmixPage => WorldPage', slideTo('left') ),
   transition('gmixPage => ImaginePage', slideTo('left') ),
   transition('gmixPage => NewsPage', slideTo('right') ),
   transition('gmixPage => StartFormPage', slideTo('right') ),

   transition('NewsPage => NoticePage', slideTo('right') ),
   transition('NoticePage => NewsPage', slideTo('left') ),

   /* transition('CryptmiPage => CymiPage', slideTo('right') ),
   transition('CymiPage => CryptmiPage', slideTo('left') )  */
 ]);

function slideTo(direction) {
 const optional = { optional: true };
 return [
   query(':enter, :leave', [
     style({
       position: 'fixed',
       top: 0,
       [direction]: 0,
       width: '100%'
     })
   ], optional),
   query(':enter', [
     style({ [direction]: '-100%'})
   ]),
   group([
     query(':leave', [
       animate('600ms ease', style({ [direction]: '100%'}))
     ], optional),
     query(':enter', [
       animate('600ms ease', style({ [direction]: '0%'}))
     ])
   ]),
 ];
}

